import { render, staticRenderFns } from "./commoditycate.vue?vue&type=template&id=459a4063&scoped=true"
import script from "./commoditycate.vue?vue&type=script&lang=js"
export * from "./commoditycate.vue?vue&type=script&lang=js"
import style0 from "./commoditycate.vue?vue&type=style&index=0&id=459a4063&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459a4063",
  null
  
)

export default component.exports